import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberReferralTypeForm from '../../../components/forms/MemberReferralTypeForm';
import { useMemberReferralTypeById, useUpdateMemberReferralType } from '../../../hooks/useMemberReferralTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberReferralTypeDTO } from '../../../services/apiClient';

const MemberReferralTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberReferralTypeById(id!);
  const updateMutation = useUpdateMemberReferralType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Referral Types', href: '/admin/memberreferraltypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberreferraltypes');
    } catch (error) {
      console.error('Error updating MemberReferralType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberreferraltypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberReferralType.Edit'
    >
        {entityData ? (
          <MemberReferralTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberreferraltypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberReferralTypeEdit;